export enum UserRole {
  User = "User",
  Administrator = "Administrator",
  ITManager = "ITManager",
}
